import { Button } from "@similarweb/ui-components";
import { EmptyState } from "@similarweb/ui-components";
import { useCurrentStateAndParams } from "@uirouter/react";
import { TOGGLE_ON_MAIN_SITE_DROPDOWN } from "app/action_types/website_analysis_action-types";
import { getUrlComponents } from "pro-features/components/AutocompleteWebsites/urlComponentUtils";
import type { IChosenItemParams } from "app/components/compare/WebsiteQueryBar/WebsitePageQueryBarUtils";
import { translate } from "app/filters/i18nFilter";
import type { FC } from "react";
import { proNavigator } from "single-spa/react-app/ProNavigator";
import { useDispatch } from "react-redux";
import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import styled from "styled-components";

const EmptyStateStyled = styled(EmptyState)`
    padding: 48px 0;
`;

const CtaButtonContainer = styled(FlexRow)`
    gap: 8px;
`;

export const TablePageFilterWithQueryParamsEmptyState: FC = () => {
    const { params } = useCurrentStateAndParams();
    const pageFilter: IChosenItemParams = JSON.parse(params.pageFilter);
    const mainPage = pageFilter?.[0];

    const dispatch = useDispatch();

    const onEdit = () => {
        dispatch({ type: TOGGLE_ON_MAIN_SITE_DROPDOWN });
    };

    const onRemoveQueryParams = () => {
        const { queryParams } = getUrlComponents(mainPage.url);
        const queryParamsLength = `?${queryParams}`.length;
        const newUrl = mainPage.url.substring(0, mainPage.url.length - queryParamsLength);
        const newParams = {
            ...params,
            pageFilter: JSON.stringify([{ ...mainPage, url: newUrl }]),
        };
        proNavigator.updateParams(newParams);
    };

    return (
        <EmptyStateStyled
            title="page.query.bar.with.query.params.empty.state.title"
            subtitle="page.query.bar.with.query.params.empty.state.subtitle"
            CtaButtons={
                pageFilter.length === 1
                    ? () => (
                          <CtaButtonContainer>
                              <Button
                                  type="flat"
                                  onClick={onEdit}
                              >
                                  {translate("page.query.bar.with.query.params.empty.state.edit.cta")}
                              </Button>
                              <Button
                                  type="primary"
                                  onClick={onRemoveQueryParams}
                              >
                                  {translate("page.query.bar.with.query.params.empty.state.remove.params.cta")}
                              </Button>
                          </CtaButtonContainer>
                      )
                    : undefined
            }
        />
    );
};
